<script lang="ts">
  import TabPanel from 'scripts/global_components/child_components/TabPanel.svelte';
  import StockList from './StockList.svelte';
  import StockCategoryList from './StockCategoryList.svelte';
  import CustomTabs from 'scripts/global_components/CustomTabs.svelte';
  import Spinner from 'scripts/global_components/child_components/Spinner.svelte';
  import { stockerPageCondition } from './store';
  const tabs = ['カテゴリー', '在庫'];
  let spinnerDisplay = false;
</script>

<CustomTabs {tabs} bind:active={$stockerPageCondition.activeTab}>
  <TabPanel name="在庫" bind:active={$stockerPageCondition.activeTab}>
    <StockList bind:spinnerDisplay />
  </TabPanel>
  <TabPanel name="カテゴリー" bind:active={$stockerPageCondition.activeTab}>
    <StockCategoryList bind:spinnerDisplay />
  </TabPanel>
</CustomTabs>
<Spinner bind:display={spinnerDisplay} />
